(function() {
	let burgerBtn = null;
	let mobileMenu = null;
	let mobileMenuOverlay = null;
	let header = null;
	let mobileMenuOpened = false;

	function setMobileMenuOpen(open) {
		if (mobileMenuOpened === open) {
			return;
		}

		mobileMenuOpened = open;
		burgerBtn.classList.toggle('button-burger_active', open);
		mobileMenu.classList.toggle('mobile-menu_open', open);
		header.classList.toggle('header_opened-mobile-menu', open);

		if (open) {
			disableScroll();
		} else {
			enableScroll();
		}
	}

	function isRootHashLink(link) {
		const href = (link.getAttribute('href') || '').trim();

		if (/^\/#[^\s#]+/.test(href)) {
			return true;
		}

		try {
			const url = new URL(link.href, window.location.origin);

			return url.origin === window.location.origin && url.pathname === '/' && url.hash.length > 1;
		} catch (error) {
			return false;
		}
	}

	document.addEventListener('DOMContentLoaded', () => {
		burgerBtn = document.querySelector('[data-target="burger-button"]');
		mobileMenu = document.querySelector('[data-target="mobile-menu"]');
		header = document.querySelector('[data-target="header"]');

		burgerBtn.addEventListener('click', function(event) {
			event.preventDefault();
			event.stopPropagation();
			
			setMobileMenuOpen(!mobileMenuOpened);
		});

		mobileMenu.addEventListener('click', function(event) {
			if (!mobileMenuOpened) {
				return;
			}

			const link = event.target.closest('a[href]');

			if (link && isRootHashLink(link)) {
				setMobileMenuOpen(false);
			}
		});

		document.addEventListener('click', function(event) {
			if (!mobileMenuOpened) {
				return;
			}

			if (mobileMenu.contains(event.target)) {
				return;
			}

			if (burgerBtn.contains(event.target)) {
				return;
			}

			setMobileMenuOpen(false);
		});
	});
})();
